import React, { useState, useContext } from 'react';
import { Box, TextField, Button, Typography } from '@mui/material';
import { VerifyEmail, ResendRegistrationOTP } from '../../api/axios'; 
import { useNavigate } from 'react-router-dom';
import Alert from '../../components/common/Alert';
import { AuthContext } from '../../context/AuthContext';

const OtpVerification = ({ email, registeredUserId, tabValue }) => {
  const [otp, setOtp] = useState('');
  const [loading, setLoading] = useState(false);
  const { login } = useContext(AuthContext);
  const navigate = useNavigate();

  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [alertSeverity, setAlertSeverity] = useState('success');
  const [alertMessage, setAlertMessage] = useState('');

  const handleOtpChange = (e) => {
    setOtp(e.target.value);
  };

  const handleVerifyOtp = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const res = await VerifyEmail({ enteredOTP: otp.trim(), email });
      if (res.success) {
        setAlertMessage('Email verified successfully! Logging you in...');
        setAlertSeverity('success');
        setOpenSnackbar(true);
        login(res.token); // Log in the user
        setTimeout(() => {
          navigate(tabValue === 0 ? '/subscriptions' : '/profile');
        }, 2000);
      } else {
        throw new Error(res.message);
      }
    } catch (error) {
      console.error('OTP verification error:', error);
      const errorMessage =
        error.response?.data?.message ||
        error.message ||
        'Something went wrong during OTP verification.';
      setAlertMessage(errorMessage);
      setAlertSeverity('error');
      setOpenSnackbar(true);
    } finally {
      setLoading(false);
    }
  };

  const handleResendOtp = async () => {
    setLoading(true);
    try {
      const res = await ResendRegistrationOTP({ email });
      if (res.success) {
        setAlertMessage('New OTP sent to your email.');
        setAlertSeverity('success');
        setOpenSnackbar(true);
      } else {
        throw new Error(res.message);
      }
    } catch (error) {
      console.error('Resend OTP error:', error);
      const errorMessage =
        error.response?.data?.message ||
        error.message ||
        'Failed to resend OTP.';
      setAlertMessage(errorMessage);
      setAlertSeverity('error');
      setOpenSnackbar(true);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        padding: 4,
        gap: 2,
      }}
    >
      <Typography variant="h5">Verify Your Email</Typography>
      <Typography variant="body1" textAlign="center">
        An OTP has been sent to <strong>{email}</strong>. Please enter it below to verify your account.
      </Typography>
      <TextField
        label="Enter OTP"
        variant="outlined"
        value={otp}
        onChange={handleOtpChange}
        fullWidth
        sx={{ maxWidth: 300 }}
      />
      <Button
        variant="contained"
        onClick={handleVerifyOtp}
        disabled={loading || otp.length !== 6}
        fullWidth
        sx={{
          maxWidth: 300,
          backgroundColor: '#6E0506 !important',
          '&:hover': {
            backgroundColor: '#6E0506 !important',
          },
          color: '#fff',
        }}
      >
        {loading ? 'Verifying...' : 'Verify OTP'}
      </Button>
      <Button
        variant="text"
        onClick={handleResendOtp}
        disabled={loading}
        sx={{ color: '#6E0506' }}
      >
        Resend OTP
      </Button>
      <Alert
        openSnackbar={openSnackbar}
        alertSeverity={alertSeverity}
        setOpenSnackbar={setOpenSnackbar}
        alertMessage={alertMessage}
      />
    </Box>
  );
};

export default OtpVerification;
